//CaribbeanWrapper.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from 'react'
import { PageTitle } from '../../../../_designereyes/layout/core'
import {
  DistributionUnitsSoldCard,
  AverageOrderValueCard,
  AccountPerformanceTable,
  TotalOpenOrdersCard,          // <- one combined card
} from '../../../../_designereyes/partials/widgets'
import {
  AccountInfoCard,
  ContractCard,
  OpenPOCard,
  TotalBalanceCard,
  useAccount,                   // context hook lives in widgets barrel
} from '../../../../_designereyes/partials/widgets'
import {
  StoreDetailsTable,
  PurchaseOrderTable,
} from '../../../../_designereyes/partials/widgets'
import { caribbeanDistributors } from '../../../../_designereyes/partials/widgets/_new/cards/vendors/distribution/distributor-data'

/* ------------ territory‑wide aggregates ------------ */
const territory = caribbeanDistributors.reduce(
  (acc, d) => {
    acc.orders     += d.TotalOrders
    acc.sales      += d.YTDSales
    acc.units      += d.Units
    acc.openCount  += d.OpenOrders
    acc.openValue  += d.TotalOpenOrderValue
    return acc
  },
  { orders: 0, sales: 0, units: 0, openCount: 0, openValue: 0 }
)

/* -----------------------  LIST PAGE  ----------------------- */

const CaribbeanPage = () => (
  <div className='row g-12 g-xl-12'>
    <div className='col-xl-3 col-lg-3 mb-4'>
      <div className='mb-4'>
        <AverageOrderValueCard
          totalOrders={territory.orders}
          totalValue={territory.sales}
        />
      </div>
      <div className='mb-4'>
        <TotalOpenOrdersCard
          openOrders={territory.openCount}
          openValue={territory.openValue}
        />
      </div>

      <div className='mb-4'>
        <DistributionUnitsSoldCard
          totalUnitsSold={territory.units}
          averageMonthlySales={Math.round(territory.units / 12)}
        />
      </div>

      
    </div>

    <div className='col-xl-9 col-lg-9'>
      <div className='mb-5 mb-xl-10'>
        <AccountPerformanceTable country='Caribbean' />
      </div>
    </div>
  </div>
)

/* -----------------------  DETAIL PAGE  ----------------------- */

const AccountPage: FC = () => {
  const { selectedAccountID, handleSelectAccount } = useAccount()

  /* find the distributor **in this territory** */
  const dist = caribbeanDistributors.find((d) => d.AccountID === selectedAccountID)

  /* If the user navigated from Israel → Caribbean with a stale ID,
     reset selection and fall back to the list page. */
  useEffect(() => {
    if (!dist) handleSelectAccount('')
    // eslint‑disable‑next‑line react‑hooks/exhaustive‑deps
  }, [dist])

  if (!dist) return null

  return (
    <>
      <button className='btn btn-sm btn-primary' onClick={() => handleSelectAccount('')}>
        Back
      </button>

      <div className='row g-5 g-xl-10 mt-1'>
        <div className='col-xl-4 col-lg-4 h-100 min-h-100'>
          <AccountInfoCard />
        </div>
        <div className='col-xl-3 col-lg-3 h-100 min-h-100'>
          <OpenPOCard quantity={dist.Units} orders={dist.OpenOrders} />
        </div>
        <div className='col-xl-3 col-lg-3 h-100 min-h-100'>
          <TotalBalanceCard balance={dist.BalanceDue} ytd={dist.YTDSales} />
        </div>
        <div className='col-xl-2 col-lg-2 h-100 min-h-100'>
          <ContractCard />
        </div>
      </div>

      <div className='row g-12 g-xl-12 mt-6'>
        <div className='col-xl-6 col-lg-6'>
          <StoreDetailsTable />
        </div>
        <div className='col-xl-6 col-lg-6'>
          <PurchaseOrderTable />
        </div>
      </div>
    </>
  )
}

/* -----------------------  WRAPPER  ----------------------- */

export const CaribbeanWrapper: FC = () => {
  const { selectedAccountID } = useAccount()

  return (
    <>
      <PageTitle>Caribbean Distribution</PageTitle>
      {selectedAccountID === '' ? <CaribbeanPage /> : <AccountPage />}
    </>
  )
}
